import axios from 'axios';
import { DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES } from '@alfa-bank/site-dc-env-config';

import type { TCategoriesApiResponse, ICategoriesApiArgs } from '../models';

export const getCategoriesApi = ({ groupType }: ICategoriesApiArgs) => {
    return axios.get<TCategoriesApiResponse>(
        DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES({ groupType })
    );
};
